import React from "react"
import { SuggestionDetail } from "../components"

export default function Suggestion({ pageContext }) {
  return <SuggestionDetail {...pageContext} />
}
